import {initMainHeader} from '../js/src/header-init';
import '../scss/pages/taa-compliance.scss';

initMainHeader();
